import React from "react";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportOnce } from "../motionVariants";

// Sourced directly from Shashank's resume.
const experienceData = [
    {
        role: "Full-Stack Software Engineer",
        org: "ENTNT, Remote",
        dates: "May 2024 — Present",
        points: [
            "Own our full-stack architecture end-to-end, and pushed adoption of AI tools like Claude, Cursor, and Codex across the team.",
            "Built an LLM pipeline (OpenAI function calling + LangChain) that catches duplicate and misspelled records across 50,000+ entries — saves ~28 hours of manual review a week.",
            "Cut upload times from 10s to 4s and bandwidth usage by 40%.",
            "Built a containerized OCR pipeline that cut manual data entry by 60%, plus a semantic search layer for de-duplication at scale.",
        ],
    },
    {
        role: "Full Stack Developer (Intern)",
        org: "SciAstra, India",
        dates: "Sep 2023 — Nov 2023",
        points: [
            "Built an 18+ page web app from scratch, including a database redesign for a real-time content feed serving 500+ active users.",
            "Cut homepage payload by 45% and page load time from 8s to 4s.",
        ],
    },
];

export default function Experience() {
    return (
        <section id="experienceRoot">
            <div className="sectionHead">
                <span className="eyebrow">Experience</span>
                <h2 className="sectionTitle">Where the impact happened</h2>
            </div>
            <motion.div
                id="timeline"
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={viewportOnce}
            >
                {experienceData.map((item, index) => (
                    <motion.div className="timelineItem" key={index} variants={fadeInUp}>
                        <div className="timelineHead">
                            <div>
                                <h3 className="timelineRole">{item.role}</h3>
                                <p className="timelineOrg">{item.org}</p>
                            </div>
                            <span className="timelineDates">{item.dates}</span>
                        </div>
                        <ul className="timelinePoints">
                            {item.points.map((point, i) => (
                                <li key={i}>{point}</li>
                            ))}
                        </ul>
                    </motion.div>
                ))}
            </motion.div>
        </section>
    );
}
